import { ClipboardContext } from '@/context/ClipboardContext';
import { useContext } from 'react';

export const useClipboard = () => useContext(ClipboardContext);
